import React from 'react';

function MouseClick() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M16.878 27.772h-.04c-.41-.02-.78-.29-.91-.68l-5-15c-.11-.36-.02-.76.25-1.02.26-.27.66-.37 1.02-.25l15 5c.39.13.67.49.68.91.02.41-.22.8-.61.96l-6.63 2.84-2.84 6.63c-.16.38-.52.61-.92.61zm-3.42-14.42l3.54 10.61 1.96-4.58c.1-.24.29-.42.53-.52l4.58-1.96-10.61-3.55z'
			></path>
			<path
				fill='#2d2d2d'
				d='M22.583 21.067L21.17 22.48l4.002 4.002 1.414-1.414-4.002-4.002zM9.748 4.002L7.9 4.769l1.15 2.77 1.848-.766-1.15-2.771zM18.89 7.792l-2.77 1.151.767 1.847 2.77-1.151-.767-1.847zM6.88 12.772l-2.77 1.151.768 1.847 2.77-1.151-.768-1.847zM14.03 4l-1.15 2.771 1.848.767 1.15-2.772L14.03 4zM9.05 16.01l-1.149 2.771 1.847.767 1.15-2.771-1.847-.767zM4.878 7.79L4.11 9.639l2.77 1.15.767-1.847-2.77-1.15z'
			></path>
		</svg>
	);
}

export default MouseClick;
